// eslint-disable-next-line quotes
import i18n from "../../../../i18n";

export const _projectBasicInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.alternativeTitle
      ? [{
        name: 'Εναλλακτικός Τίτλος',
        value: '',
        refValue: 'alternativeTitle',
      }] :
      []),
    // ...(_mappedMetadata?.projectId
    //   ? [{
    //     name: 'Αναγνωριστικό Έργου',
    //     value: '',
    //     refValue: 'projectId',
    //   }] :
    //   []),
    ...(_mappedMetadata?.projectType
      ? [{
        name: 'Τύπος Έργου',
        value: '',
        refValue: 'projectType',
      }] :
      []),
    ...(_mappedMetadata?.projectDescription && i18n.language === 'el'
      ? [{
        name: 'Περιγραφή Έργου',
        value: '',
        refValue: 'projectDescription',
      }] :
      []),
    ...(_mappedMetadata?.projectEnDescription && i18n.language === 'en'
      ? [{
        name: 'Περιγραφή Έργου',
        value: '',
        refValue: 'projectEnDescription',
      }] :
      []),
    ...(_mappedMetadata?.projectBelongsTo
      ? [{
        name: 'Ανήκει σε',
        value: '',
        refValue: 'projectBelongsTo',
      }] :
      []),
    ...(_mappedMetadata?.countryOrigin
      ? [{
        name: 'Χώρα Παραγωγής',
        value: '',
        refValue: 'countryOrigin',
      }] :
      []),
    ...(_mappedMetadata?.projectLanguage
      ? [{
        name: 'Γλώσσα',
        value: '',
        refValue: 'projectLanguage',
      }] :
      []),
    ...(_mappedMetadata?.projectYear
      ? [{
        name: 'Χρονολογία',
        value: '',
        refValue: 'projectYear',
      }] :
      []),
    ...(_mappedMetadata?.projectDuration
      ? [{
        name: 'Διάρκεια',
        value: '',
        refValue: 'projectDuration',
      }] :
      []),
    ...(_mappedMetadata?.projectFormat
      ? [{
        name: 'Μορφότυπο',
        value: '',
        refValue: 'projectFormat',
      }] :
      []),
    ...(_mappedMetadata?.projectColor
      ? [{
        name: 'Χρώμα',
        value: '',
        refValue: 'projectColor',
      }] :
      []),
    ...(_mappedMetadata?.projectSound
      ? [{
        name: 'Ήχος',
        value: '',
        refValue: 'projectSound',
      }] :
      []),
    ...(_mappedMetadata?.projectSize
      ? [{
        name: 'Μέγεθος',
        value: '',
        refValue: 'projectSize',
      }] :
      []),
    ...(_mappedMetadata?.projectHeight
      ? [{
        name: 'Ύψος',
        value: '',
        refValue: 'projectHeight',
      }] :
      []),
    ...(_mappedMetadata?.projectWidth
      ? [{
        name: 'Πλάτος',
        value: '',
        refValue: 'projectWidth',
      }] :
      []),
    ...(_mappedMetadata?.projectFrameRate
      ? [{
        name: 'Frame Rate',
        value: '',
        refValue: 'projectFrameRate',
      }] :
      []),
    ...(_mappedMetadata?.projectAspectRatio
      ? [{
        name: 'Aspect Ratio',
        value: '',
        refValue: 'projectAspectRatio',
      }] :
      []),
    ...(_mappedMetadata?.projectOtherLocations
      ? [{
        name: 'Άλλες Τοποθεσίες',
        value: '',
        refValue: 'projectOtherLocations',
      }] :
      []),
    ...(_mappedMetadata?.projectLicense
      ? [{
        name: 'Άδεια Χρήσης',
        value: '',
        refValue: 'projectLicense',
      }] :
      []),
    ...(_mappedMetadata?.projectKeywords
      ? [{
        name: 'Λέξεις Κλειδιά',
        value: '',
        refValue: 'projectKeywords',
      }] :
      []),
    ...(_mappedMetadata?.projectCopyrights
      ? [{
        name: 'Copyrights',
        value: '',
        refValue: 'projectCopyrights',
      }] :
      []),
    ...(_mappedMetadata?.projectEnComments && i18n.language === 'el'
      ? [{
        name: 'Παρατηρήσεις - Σχόλια Έργου',
        value: '',
        refValue: 'projectComments',
      }] :
      []),
    ...(_mappedMetadata?.projectEnComments && i18n.language === 'en'
      ? [{
        name: 'Παρατηρήσεις - Σχόλια Έργου',
        value: '',
        refValue: 'projectEnComments',
      }] :
      []),
    ...(_mappedMetadata?.projectLocation
      ? [{
        name: 'Σχετικές Τοποθεσίες',
        value: '',
        refValue: 'projectLocation',
      }] :
      []),
  ];
};

export const _projectSyntelestes = [
  {
    name: 'Ονοματεπώνυμο',
    value: '',
    refValue: 'fullname',
  },
  {
    name: 'Ψευδώνυμο',
    value: '',
    refValue: 'pseudonym',
  },
  {
    name: 'Έτος Γέννησης',
    value: '',
    refValue: 'birthDate',
  },
  {
    name: 'Ιδιότητα στο Έργο',
    value: '',
    refValue: 'projectRole',
  }
];

export const _projectEducationalInfo = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.projectEducational
      ? [{
        name: 'Εκπαιδευτικό',
        value: '',
        refValue: 'projectEducational',
      }] :
      []),
    ...(_mappedMetadata?.projectEduInstitution
      ? [{
        name: 'Εκπαιδευτικό Ίδρυμα',
        value: '',
        refValue: 'projectEduInstitution',
      }] :
      []),
    ...(_mappedMetadata?.projectEduLevel
      ? [{
        name: 'Εκπαιδευτική Βαθμίδα',
        value: '',
        refValue: 'projectEduLevel',
      }] :
      []),
    ...(_mappedMetadata?.trainer
      ? [{
        name: 'Εκπαιδευτής',
        value: '',
        refValue: 'trainer',
      }] :
      []),
    ...(_mappedMetadata?.projectLab
      ? [{
        name: 'Εργαστήριο',
        value: '',
        refValue: 'projectLab',
      }] :
      []),
    ...(_mappedMetadata?.creationTeam
      ? [{
        name: 'Ομάδα Δημιουργίας',
        value: '',
        refValue: 'creationTeam',
      }] :
      []),
    ...(_mappedMetadata?.projectNumberPlayers
      ? [{
        name: 'Αριθμός Παικτών',
        value: '',
        refValue: 'projectNumberPlayers',
      }] :
      []),
    ...(_mappedMetadata?.projectsMutualGoal
      ? [{
        name: 'Κοινός Στόχος',
        value: '',
        refValue: 'projectsMutualGoal',
      }] :
      []),
    ...(_mappedMetadata?.organization
      ? [{
        name: 'Διοργάνωση',
        value: '',
        refValue: 'organization',
      }] :
      []),
    ...(_mappedMetadata?.awards
      ? [{
        name: 'Βραβεία',
        value: '',
        refValue: 'awards',
      }] :
      []),


  ];
};
